<template>
<div class="chapter">
<div class="inner_page">
<h1>chapter 1</h1>
<h1 class="h1a"><a id="chapter01"></a><a id="page_12"></a><strong>VEGETABLE ESSENTIALS</strong></h1>
<div class="image_wrap">
<p class="image_horiz"><img alt="image" height="auto" src="images/f0012-01.jpg" width="100%"/></p>
</div>
<div class="pagebreak">
<p class="toc-sectop"><a id="page_13"></a><a href="#/xhtml/08chapter01sec01"><strong>GALLERY OF ITALIAN VEGETABLES</strong> 15</a></p>
<p class="toc-sec"><span href="#/xhtml/09chapter01sec02" title="Link target outside of Sample"><strong>HERBS</strong> 41</span></p>
<p class="toc-sec"><span href="#/xhtml/10chapter01sec03" title="Link target outside of Sample"><strong>INGREDIENTS</strong> 43</span></p>
<p class="toc-sec"><span href="#/xhtml/11chapter01sec04" title="Link target outside of Sample"><strong>EQUIPMENT</strong> 49</span></p>
<p class="toc-sec1"><span href="#/xhtml/12chapter01sec05" title="Link target outside of Sample"><strong>BASIC RECIPES</strong> 54</span></p>
<p class="toc-sec"><span href="#/xhtml/13chapter01sec05a" title="Link target outside of Sample">FRESH EGG PASTA DOUGH 55</span></p>
<p class="toc-sec"><span href="#/xhtml/14chapter01sec05b" title="Link target outside of Sample">SPINACH PASTA DOUGH 58</span></p>
<p class="toc-sec"><span href="#/xhtml/15chapter01sec05c" title="Link target outside of Sample">FLAKY PASTRY DOUGH 60</span></p>
<p class="toc-sec"><span href="#/xhtml/16chapter01sec05d" title="Link target outside of Sample">SWEET PASTRY DOUGH 61</span></p>
<p class="toc-sec"><span href="#/xhtml/17chapter01sec05e" title="Link target outside of Sample">VEGETABLE BROTH 62</span></p>
<p class="toc-sec"><span href="#/xhtml/18chapter01sec05f" title="Link target outside of Sample">FRESH BASIL PESTO 64</span></p>
<p class="toc-sec"><span href="#/xhtml/19chapter01sec05g" title="Link target outside of Sample">FRESH TOMATO SAUCE 65</span></p>
<p class="toc-sec"><span href="#/xhtml/20chapter01sec05h" title="Link target outside of Sample">SIMPLE TOMATO SAUCE 66</span></p>
<p class="toc-sec"><span href="#/xhtml/21chapter01sec05i" title="Link target outside of Sample">SLOW-ROASTED TOMATOES 67</span></p>
<p class="toc-sec"><span href="#/xhtml/22chapter01sec05j" title="Link target outside of Sample">ROASTED FENNEL 68</span></p>
<p class="toc-sec"><span href="#/xhtml/23chapter01sec05k" title="Link target outside of Sample">ROASTED MUSHROOMS 69</span></p>
<p class="toc-sec"><span href="#/xhtml/24chapter01sec05l" title="Link target outside of Sample">ROASTED WINTER SQUASH PURÉE 70</span></p>
<p class="toc-sec"><span href="#/xhtml/25chapter01sec05m" title="Link target outside of Sample">BASIC BEANS IN A POT 71</span></p>
<p class="toc-sec"><span href="#/xhtml/26chapter01sec05n" title="Link target outside of Sample">GRILLED PEPPERS 74</span></p>
<p class="toc-sec"><span href="#/xhtml/27chapter01sec05o" title="Link target outside of Sample">SAUTÉED RAPINI 75</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06chapter01.vue?59c02034